import { render, staticRenderFns } from "./IncentifyerAccounts.vue?vue&type=template&id=fa0d6adc&"
import script from "./IncentifyerAccounts.vue?vue&type=script&lang=js&"
export * from "./IncentifyerAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports